import React, { useState } from "react";
import { IMAGES, PILLARS } from "../../data/mock";
import Reveal from "./Reveal";
import { ArrowUpRight } from "lucide-react";

export default function Pillars() {
  const [active, setActive] = useState(0);
  return (
    <section id="pillars" className="relative py-28 md:py-40 border-b hairline overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 text-[var(--text-muted)] mb-8">
          <span className="h-px w-8 bg-[var(--line-2)]"></span>
          <span className="font-mono text-[10px] uppercase tracking-[0.3em]">The Four Pillars</span>
        </div>
        <Reveal>
          <h2 className="font-display text-[54px] md:text-[110px] leading-[0.94] tracking-[-0.03em]">
            Body. Heart.<br />Mind. <span className="italic-serif text-[var(--ember-3)]">Home</span>.
          </h2>
        </Reveal>
        <Reveal delay={150}>
          <p className="mt-8 max-w-[640px] text-[var(--text-muted)] text-[17px] leading-[1.75]">
            Four foundations. Sharpened in parallel. Because the strongest body in the world cannot lead a family whose head is weak or whose heart is hard.
          </p>
        </Reveal>

        <div className="mt-20 grid md:grid-cols-[1fr_1.05fr] gap-10 md:gap-16 items-start">
          {/* Left: interactive list */}
          <div className="divide-y hairline border-t border-b hairline">
            {PILLARS.map((p, i) => (
              <div key={p.n}
                onMouseEnter={() => setActive(i)}
                onClick={() => setActive(i)}
                className={`group cursor-pointer py-8 md:py-10 flex gap-6 items-start transition-colors ${active === i ? "" : ""}`}>
                <div className="font-mono text-[11px] tracking-[0.2em] text-[var(--text-muted)] pt-2">— Pillar {p.n} —</div>
                <div className="flex-1">
                  <div className="flex items-baseline justify-between gap-6">
                    <h3 className={`font-display text-[32px] md:text-[46px] leading-[1] tracking-[-0.02em] transition-colors ${active === i ? "text-[var(--ember-3)]" : "text-[var(--text)] group-hover:text-[var(--ember-3)]"}`}>{p.title}</h3>
                    <ArrowUpRight size={22} className={`transition-all duration-500 ${active === i ? "rotate-45 text-[var(--ember-2)]" : "text-[var(--text-muted)] group-hover:text-[var(--ember-2)]"}`} />
                  </div>
                  <div className={`overflow-hidden transition-[max-height,opacity] duration-700 ease-out ${active === i ? "max-h-[240px] opacity-100 mt-5" : "max-h-0 opacity-0"}`}>
                    <p className="text-[var(--text-muted)] text-[15.5px] leading-[1.75] max-w-[520px]">{p.body}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Right: image stack */}
          <div className="relative aspect-[4/5] md:sticky md:top-24 pillar-card border hairline-2">
            {PILLARS.map((p, i) => (
              <div key={p.n} className={`absolute inset-0 transition-opacity duration-700 ${active === i ? "opacity-100" : "opacity-0"}`}>
                <img src={IMAGES[p.img]} alt={p.title} className="w-full h-full object-cover img" />
                <div className="veil"></div>
                <div className="absolute left-8 bottom-8 right-8">
                  <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[var(--ember-3)]">Pillar {p.n}</div>
                  <div className="font-display text-[38px] md:text-[48px] leading-[1] mt-2">{p.title}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
